import { useState } from "react"
import * as ToggleGroup from "@radix-ui/react-toggle-group"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, Link, redirect } from "@tanstack/react-router"
import Cookies from "js-cookie"

import {
  getAnnouncement,
  getLatestAnnouncement,
  validateAnnouncementPermission,
} from "@/lib/api/announcement"
import { canViewThisPage } from "@/lib/api/auth"
import { cn, formatDateAndTime } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from "@/components/ui/credenza"
import { AnnouncementForm } from "@/components/forms/announcement-form"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"

export const Route = createFileRoute("/_home/announcement/")({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_announcements")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: AnnouncementPage,
})

function AnnouncementPage() {
  const [showSelectedCategory, setShowSelectedCategory] =
    useState<boolean>(false)

  const { data: latestAnnouncement, isLoading } = useQuery({
    queryKey: ["latestAnnouncement"],
    queryFn: getLatestAnnouncement,
  })
  return (
    <main className="space-y-4 p-4">
      <div className="flex gap-2">
        <Header>Announcements</Header>
      </div>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <div className="col-span-2">
          <AnnouncementForm />
        </div>
        <div>
          <div className="mb-4 flex justify-end">
            <Link to="/announcement/overall-announcement">
              <Button>
                <Icons.view />
                View Previous Announcements
              </Button>
            </Link>
          </div>
          <Card className="w-full">
            <div className="w-full overflow-hidden">
              <img
                src="card-image-sampler.png"
                className="h-44 w-full object-cover"
              />
            </div>
            <CardHeader className="text-lg font-bold">
              <CardTitle className="text-2xl font-medium">
                <div className="flex items-center gap-2">
                  <Icons.partyPopper className="text-primary" />
                  <Icons.partyPopper className="text-primary" />
                  Latest Announcement
                  <Icons.partyPopper className="text-primary" />
                  <Icons.partyPopper className="text-primary" />
                </div>
              </CardTitle>
              <CardDescription className="flex flex-col py-2">
                <span className="py-3 text-3xl font-medium text-muted-foreground">
                  {latestAnnouncement?.subject}
                </span>
                <span className="text-sm font-bold text-muted-foreground">
                  {`${latestAnnouncement?.created_by} | ${formatDateAndTime(latestAnnouncement?.created_at)}`}
                </span>
              </CardDescription>
            </CardHeader>
            <CardContent>
              <CardDescription>
                <span className="text-lg font-medium">
                  {latestAnnouncement?.header}
                </span>
                <br />
                <br />
                {latestAnnouncement?.body}
              </CardDescription>
            </CardContent>
            <CardFooter className="text-sm font-semibold">
              <Credenza>
                <CredenzaTrigger asChild>
                  <span className="flex cursor-pointer px-0 text-primary underline">
                    Read more <Icons.doubleRight />
                  </span>
                </CredenzaTrigger>
                <CredenzaContent className="max-h-[90vh] max-w-3xl overflow-y-auto">
                  <CredenzaHeader>
                    <CredenzaTitle className="text-2xl">
                      <div className="flex items-center justify-center gap-2">
                        <Icons.partyPopper className="text-primary" />
                        <Icons.partyPopper className="text-primary" />
                        Latest Announcement
                        <Icons.partyPopper className="text-primary" />
                        <Icons.partyPopper className="text-primary" />
                      </div>
                    </CredenzaTitle>
                    <CredenzaDescription className="flex flex-col py-2">
                      <span className="text-xl font-medium">
                        {latestAnnouncement?.subject}
                      </span>
                      <span className="text-sm font-bold">
                        {`${latestAnnouncement?.created_by} | ${formatDateAndTime(latestAnnouncement?.created_at)}`}
                      </span>
                      <br />
                      <span className="text-lg font-medium">
                        {latestAnnouncement?.header}
                      </span>
                      <br />
                      <br />
                      {latestAnnouncement?.body}
                      {/*     We would like to inform you that Digos Water District will
                                    be conducting a scheduled water interruption for
                                    maintenance works. Please take note of the following
                                    details:
                                    <br />
                                    <strong>Scheduled Water Interruption Details:</strong>
                                    <br />
                                    <strong>Date of Interruption:</strong> April 07, 2025
                                    <br />
                                    <strong>Start Time:</strong> 06:00 PM
                                    <br />
                                    <strong>End Time:</strong> 11:00 PM
                                    <br />
                                    <br />
                                    <strong>Affected Areas:</strong> During this time, water
                                    supply will be temporarily unavailable in the areas
                                    mentioned above. We kindly ask for your understanding and
                                    cooperation as we work to improve the water supply system.
                                    <br />
                                    <br />
                                    <strong>Thank you for your continued support.</strong> */}
                    </CredenzaDescription>
                  </CredenzaHeader>
                </CredenzaContent>
              </Credenza>
            </CardFooter>
          </Card>
        </div>
      </div>
    </main>
  )
}
